import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { VhToastService } from './toast.service';

/**
 * Absolute-positioned toast stack. Mount once per app shell.
 */
@Component({
  selector: 'vh-toast-container',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="vh-toasts" aria-live="polite" aria-atomic="true">
      @for (t of toasts.toasts(); track t.id) {
        <div class="vh-toasts__item vh-toasts__item--{{ t.type }}">
          <span class="vh-toasts__icon" aria-hidden="true">{{ icon(t.type) }}</span>
          <span class="vh-toasts__msg">{{ t.message }}</span>
          <button
            type="button"
            class="vh-toasts__close"
            aria-label="Dismiss"
            (click)="toasts.dismiss(t.id)"
          >
            &times;
          </button>
        </div>
      }
    </div>
  `,
  styleUrl: './toast-container.component.scss',
})
export class VhToastContainerComponent {
  readonly toasts = inject(VhToastService);

  icon(type: string): string {
    switch (type) {
      case 'success':
        return '✓';
      case 'warning':
        return '⚠';
      case 'error':
        return '!';
      default:
        return 'ℹ';
    }
  }
}
